import { getRandomNum } from "./numbers";

export const COLOR_DEFAULT = "#577590";
export const COLOR_COMPARING = "#f9c74f";
export const COLOR_SWAP = "#f94144";
export const COLOR_SORTED = "#90be6d";
export const COLOR_SUBARRAY_1 = "#F9FBF2";
export const COLOR_SUBARRAY_2 = "#252323";
export const COLOR_PIVOT = "#FF784F";
export const COLOR_PIVOT_INDEX = "#1D8A99";
export const COLOR_GREATER = "#EFD6AC";
export const COLOR_LESSER = "#1B5299";

export default {
	COLOR_DEFAULT,
	COLOR_COMPARING,
	COLOR_SWAP,
	COLOR_SORTED,
	COLOR_SUBARRAY_1,
	COLOR_SUBARRAY_2,
	COLOR_PIVOT,
	COLOR_PIVOT_INDEX,
	COLOR_GREATER,
	COLOR_LESSER,
};

export function getRandomColor() {
	return RANDOM_COLORS[getRandomNum(0, RANDOM_COLORS.length - 1)];
}

export const RANDOM_COLORS = [
	"#AFD5AA",
	"#F0F2EF",
	"#5C5346",
	"#A69F98",
	"#8C6057",
	"#5BC0EB",
	"#FDE74C",
	"#9BC53D",
	"#E55934",
	"#FA7921",
	"#729EA1",
	"#B5BD89",
	"#DFBE99",
	"#EC9192",
	"#DB5375",
	"#283d3b",
	"#197278",
	"#edddd4",
	"#c44536",
	"#555b6e",
	"#89b0ae",
	"#bee3db",
	"#ffd6ba",
	"#e6b89c",
	"#cad2c5",
	"#84a98c",
	"#52796f",
	"#354f52",
	"#2f3e46",
	"#64a6bd",
	"#90a8c3",
	"#ada7c9",
	"#d7b9d5",
	"#f4cae0",
	"#114b5f",
	"#1a936f",
	"#88d498",
	"#c6dabf",
	"#f3e9d2",
	"#ed6a5a",
	"#f4f1bb",
	"#9bc1bc",
	"#5ca4a9",
	"#e6ebe0",
	"#0081a7",
	"#00afb9",
	"#fdfcdc",
	"#fed9b7",
	"#f07167",
	"#3d5a80",
	"#98c1d9",
	"#e0fbfc",
	"#ee6c4d",
	"#293241",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
	// "#772e25",
];
